import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function ErrorHandler({ status, errorMessage }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 404) {
      // Redirect to a custom 404 page
      navigate("/error-404");
    } else if (status === 401) {
      // Redirect to the login page and pass the current location
      const url = `/sign-in?redirect=${window.location.pathname}`;
      navigate(url);
    } else {
      // Handle other errors, maybe navigate to a generic error page
      navigate("/error");
    }
  }, [status, navigate]);

  if (status) {
    return (
      <div className="error-handler">
        <p>
          Error: {status} - {errorMessage}
        </p>
      </div>
    );
  }

  return null;
}

export default ErrorHandler;
